/* combo plugin with some of its custom styles in the node-modules dir */

require('./style.less');

var JQR = require('jquery-ui-resizable');
module.exports = JQR;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/vendor/bundle/jquery-ui-resizable/bundle.js
 ** module id = 375
 ** module chunks = 0
 **/